import React from 'react'
import { EmblaCarouselType } from 'embla-carousel'

import { DefaultPagination } from './DefaultPagination'
import { useNavigation } from '../hooks/useNavigation'

import styles from './styles.module.css'

export interface IPaginationProps {
  children?: (current: number, total: number) => React.ReactNode
  startIndex: number
  emblaApi?: EmblaCarouselType
}

export const Pagination = ({ children, startIndex, emblaApi }: IPaginationProps) => {
  const { currentPage, numberOfPages } = useNavigation({ startIndex, emblaApi })

  return (
    <div className={styles.pagination}>
      {children ? (
        children(currentPage, numberOfPages)
      ) : (
        <DefaultPagination current={currentPage} total={numberOfPages} />
      )}
    </div>
  )
}

Pagination.displayName = 'Carousel.Pagination'
